module.exports = __webpack_public_path__ + "static/media/me.ab605c57.jpeg";